import { render, staticRenderFns } from "./Tramites.vue?vue&type=template&id=15d3b6a8"
import script from "./Tramites.vue?vue&type=script&lang=js"
export * from "./Tramites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports